import React from 'react'

const UploadsPage = () => {
  return (
    <div>
      Uploads
    </div>
  );
};

export default UploadsPage;
